<template>
  <footer class="bg-light py-4" v-if="!isEditor">
    <div class="container text-center text-md-start">
      <div class="row">
        <!-- Logo and Social Media -->
        <div class="col-md-8 col-xs-12 mb-4 pl-125">
          <div class="mb-15">
            <img src="/assets/logo.png" alt="ce:koon logo" class="mb-2" />
          </div>
          <div class="mb-15">
            <p class="text-follow">Follow #cekoonproducts</p>
            <div class="d-flex justify-content-center justify-content-md-start">
              <a href="#" class="text-dark me-3"><i class="fab size-custom fa-instagram"></i></a>
              <a href="#" class="text-dark me-3"><i class="fab size-custom fa-facebook"></i></a>
              <a href="#" class="text-dark me-3"><i class="fab size-custom fa-pinterest"></i></a>
              <a href="#" class="text-dark"><i class="fab size-custom fa-linkedin"></i></a>
            </div>
          </div>

          <p class="text-footer-company">A Product of Wako GmbH</p>
          <div class="text-footer-address">
            <p>Strasserau 6, 4020 Linz, Austria</p>
            <p>Granitleweg 4, 4202 Kirchschlag, Austria</p>
          </div>

          <div class="text-phone-email">
            <p>Phone: +43 664 5462070</p>
            <p>Email: <a href="mailto:office@cekoon.com">office@cekoon.com</a></p>
          </div>
        </div>

        <!-- Links -->
        <div class="col-md-4 col-xs-12 mt-contact pr-125">
          <button class="btn-contact-us">Contact us</button>
          <ul class="menu-footer list-unstyled">
            <li><a href="#" class="text-dark">Terms of service</a></li>
            <li><a href="#" class="text-dark">Imprint</a></li>
            <li><a href="#" class="text-dark">FAQ</a></li>
            <li><a href="#" class="text-dark">Contact</a></li>
            <li><a href="#" class="text-dark">Shipping and payment methods</a></li>
            <li><a href="#" class="text-dark">Cancellation terms</a></li>
            <li><a href="#" class="text-dark">Privacy policy</a></li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div class="mt-4 copyright">
        <small>Copyright &copy; 2024 cekoon prosthesis covers</small>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import pkg from '../../../package.json';

@Component
export default class Footer extends Vue {
  @Prop({ default: false }) isEditor!: boolean;

  privacyUri = 'https://www.aidddo.com/datenschutzerklaerung/';
  copyrightUri = 'https://www.aidddo.com/impressum/';
  version = pkg.version;
}
</script>

<style scoped lang="scss">
#footer {
  color: white;
  height: auto;
  background: #d9d9d9;
  font-weight: normal;
}
.logo-cekoon-footer {
  width: 283px;
  height: 72px;
}
.mb-15 {
  margin-bottom: 60px;
}
.btn-contact-us {
  width: 147px;
  height: 54px;
  color: #1d1e19;
  font-size: 20px;
  margin-bottom: 26px;
}

.menu-footer li a {
  font-size: 20px;
  font-weight: 400;
  text-decoration: none;
  color: #1d1e19;
}

.menu-footer li {
  line-height: 23px;
  margin-bottom: 8px;
}
.text-footer-company {
  font-weight: bold;
  font-size: 20px;
}

.text-footer-address {
  font-weight: 400;
  font-size: 20px;
  margin-bottom: 20px;
}

.text-footer-address p {
  margin: 0;
}
.text-phone-email {
  font-weight: 400;
  font-size: 20px;
}
.text-phone-email p {
  margin: 0;
}
.text-phone-email a {
  color: #1d1e19;
  text-decoration: none;
}
.text-follow {
  font-size: 20px;
}
.size-custom {
  font-size: 30px;
}
.mt-contact {
  margin-top: 90px;
}
.copyright {
  border-top: 1px solid #1d1e19;
  padding-top: 10px;
  font-size: 18px;
  font-weight: 300;
  color: #1d1e19;
  text-align: right;
}
.pl-125 {
  padding-left: 125px;
}
.pr-125 {
  padding-right: 125px;
}

@media (max-width: 768px) {
  .mt-contact {
    margin-top: 20px;
  }
  .pl-125 {
    padding-left: 0;
  }
  .pr-125 {
    padding-right: 0;
  }
}
</style>
